import { useNavigate } from "react-router-dom";

import { useNotify, useDataProvider } from "react-admin";
import { Button } from "@mui/material";
import NotesIcon from "@mui/icons-material/Notes";

import { candidateRequests } from "api/candidateApi";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import { useNotifyError } from "utils/useNotifyError";

export const EnrollingButton = ({ candidacyId, specialityId }) => {
  const navigate = useNavigate();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const notifyError = useNotifyError();

  const handleClick = async () => {
    try {
      const res = await dataProvider.customRequest(
        candidateRequests.candidacySpecialityStudentStatus(candidacyId, specialityId),
      );

      const isExistingPaidStudent = res?.data?.isExistingPaidEducationStudent;

      if (!isExistingPaidStudent) {
        navigate(`/candidate/ksk`, {
          state: { candidacyId: candidacyId, specialityId: specialityId },
        });
        return;
      }
      // existing paid-education student -> leave modal open for confirmation
    } catch (error) {
      notifyError(error);
      return false;
    }
  };

  const handleTransferConfirm = async () => {
    // permission for PUT

    if (!checkPermission(getPermissions(), permissions.canTransferStudentToStateOrder)) {
      notify("Нямате права да прехвърляте студенти.", { type: "warning" });
      return;
    }

    await dataProvider.customRequest(
      candidateRequests.transferStudentToStateOrder(candidacyId, specialityId),
      null,
      "PUT",
    );
    notify("Успешно прехвърляне към държавна поръчка.", { type: "success" });
    // after successful transfer, navigate to the same creation route
    navigate(`/candidate/ksk`, {
      state: { candidacyId: candidacyId, specialityId: specialityId },
    });
  };

  return (
    <ConfirmModal
      triggerButton={
        <Button
          variant="contained"
          color="primary"
          startIcon={<NotesIcon />}
          size="medium"
        >
          Записване
        </Button>
      }
      onOpen={handleClick}
      titleContent="Вече съществува студент платено обучение с това ЕГН. Искате ли да бъде прехвърлен в държавна поръчка?"
      onConfirm={handleTransferConfirm}
      saveTitle="Потвърди"
      closeTitle="Отказ"
    />
  );
};
